module.exports = __webpack_public_path__ + "img/allergens-2.7c9f6cb8.png";